/*
 *
 * Settings actions
 *
 */

import {
  FLUSH_STATE_SETTINGS,
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
} from './constants';

/**
 * Clearing the state for Settings
 */
export function flushStateSettings() {
  return {
    type: FLUSH_STATE_SETTINGS,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Settings, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_SETTINGS
 */
export function loadSettings() {
  return {
    type: LOAD_SETTINGS,
  };
}

/**
 * Dispatched when the loadSettings are loaded by the request saga
 *
 * @param  {array} variables true for Settings
 *
 * @return {array} An action object with a type of LOAD_SETTINGS_SUCCESS passing the variables
 */
export function loadSettingsSuccess(settingsList) {
  return {
    type: LOAD_SETTINGS_SUCCESS,
    settingsList,
  };
}

/**
 * Dispatched when loading the loadSettings fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_SETTINGS_ERROR passing the error
 */
export function loadSettingsError(error) {
  return {
    type: LOAD_SETTINGS_ERROR,
    error,
  };
}